var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserExists(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FCFCFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.832 25.3333C37.832 26.3882 37.5192 27.4193 36.9332 28.2964C36.3472 29.1734 35.5142 29.857 34.5397 30.2607C33.5651 30.6644 32.4928 30.77 31.4582 30.5642C30.4237 30.3584 29.4733 29.8504 28.7275 29.1046C27.9816 28.3587 27.4736 27.4084 27.2678 26.3738C27.0621 25.3392 27.1677 24.2669 27.5713 23.2924C27.975 22.3178 28.6586 21.4849 29.5357 20.8988C30.4127 20.3128 31.4439 20 32.4987 20C33.9132 20 35.2697 20.5619 36.2699 21.5621C37.2701 22.5623 37.832 23.9188 37.832 25.3333ZM36.4987 36H28.4987C26.7306 36 25.0349 36.7024 23.7847 37.9526C22.5344 39.2029 21.832 40.8986 21.832 42.6667V42.6667C21.832 43.0203 21.9725 43.3594 22.2226 43.6095C22.4726 43.8595 22.8117 44 23.1654 44H41.832C42.1857 44 42.5248 43.8595 42.7748 43.6095C43.0249 43.3594 43.1654 43.0203 43.1654 42.6667C43.1654 40.8986 42.463 39.2029 41.2127 37.9526C39.9625 36.7024 38.2668 36 36.4987 36Z",
    stroke: "#E94747",
    strokeWidth: 2.672,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserExists);
export default __webpack_public_path__ + "static/media/userExists.1fda40c4cec708ad6a419ccb79ea3fe8.svg";
export { ForwardRef as ReactComponent };